import React, { ReactNode } from "react";
import { cn } from "@/utils/classes";

/* Prop Types */
interface CardBadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

/*
 * CardBadge Component
 */
export const CardBadge = ({ children, className }: CardBadgeProps) => {
  return <div className={cn("badge badge-lg text-sm shadow-md rounded-lg flex py-1.5 px-2.5 h-auto items-center gap-2 absolute top-4 right-4", className)}>{children}</div>;
};
